import { render, staticRenderFns } from "./WarningList.vue?vue&type=template&id=3c68a551&scoped=true&"
import script from "./WarningList.vue?vue&type=script&lang=js&"
export * from "./WarningList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c68a551",
  null
  
)

export default component.exports